import React, { useState } from 'react';
import { Button } from '../../ui/Button';
import { Alert } from '../../ui/Alert';

export const DeleteContactModal = ({ contact, onConfirm, onClose }) => {
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState('');

  const handleConfirm = async () => {
    setDeleting(true);
    setError('');
    try {
      await onConfirm();
    } catch (err) {
      setError(err.message || 'Could not delete this contact.');
      setDeleting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 p-4">
      <div className="bg-white w-full max-w-sm rounded-3xl p-6 space-y-4 shadow-xl">
        <h2 className="text-xl font-bold text-slate-900 tracking-tight">Delete contact?</h2>
        <p className="text-sm text-slate-600">
          <span className="font-bold">{contact.full_name || 'This contact'}</span> will be permanently deleted. This cannot be undone.
        </p>
        {error && <Alert variant="error" message={error} />}
        <div className="flex justify-end gap-3">
          <Button variant="secondary" onClick={onClose} disabled={deleting}>Cancel</Button>
          <Button variant="danger" onClick={handleConfirm} isLoading={deleting}>Delete</Button>
        </div>
      </div>
    </div>
  );
};